<template>
  <h2>{{translatedText}}</h2>
</template>

<script>

export default {
  name: 'translateOutput',
  props:['translatedText']

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// TranslateOutput.vue?370d8f46